import { api_url } from "./Config";

const url = api_url;

export async function registerUserApi(data) {
  try {
    const response = await fetch(`${url}/auth/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "access-control-allow-origin": "*",
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}

export async function loginUserApi(data) {
  try {
    const response = await fetch(`${url}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "access-control-allow-origin": "*",
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}

export async function addressToIdApi(address) {
  try {
    const response = await fetch(`${url}/auth/idAddressToId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "access-control-allow-origin": "*",
      },
      body: JSON.stringify({ address }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}

export async function buyPackageApi(data, jwt) {
  try {
    const response = await fetch(`${url}/auth/buy-package`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "access-control-allow-origin": "*",
        authorization: "Bearer " + jwt,
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    console.log(err, " errr");
    return false;
  }
}

export async function claimFreeToken(jwt) {
  try {
    const response = await fetch(`${url}/auth/claim-airdrop`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "access-control-allow-origin": "*",
        authorization: "Bearer " + jwt,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    console.log(err, " errr");
    return false;
  }
}

export async function getUserDataApi(jwt) {
  try {
    const response = await fetch(`${url}/auth/user-info`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "access-control-allow-origin": "*",
        authorization: "Bearer " + jwt,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}

export async function getDirectListApi(jwt, page = 1, limit = 10) {
  try {
    const response = await fetch(
      `${url}/list/direct-list?page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "access-control-allow-origin": "*",
          authorization: "Bearer " + jwt,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}

export async function getTeamListApi(jwt, page = 1, limit = 10) {
  try {
    const response = await fetch(
      `${url}/list/get-team?page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "access-control-allow-origin": "*",
          authorization: "Bearer " + jwt,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}

export async function getStakeListApi(jwt, page = 1, limit = 10) {
  try {
    const response = await fetch(
      `${url}/list/stake-list?page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "access-control-allow-origin": "*",
          authorization: "Bearer " + jwt,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}

export async function getRoiListApi(jwt, page = 1, limit = 10) {
  try {
    const response = await fetch(
      `${url}/list/roi-list?page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "access-control-allow-origin": "*",
          authorization: "Bearer " + jwt,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}

export async function getLevelIncomeListApi(jwt, page = 1, limit = 10) {
  try {
    const response = await fetch(
      `${url}/list/level-income-list?page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "access-control-allow-origin": "*",
          authorization: "Bearer " + jwt,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}

export async function getSalaryIncomeListApi(jwt, page = 1, limit = 10) {
  try {
    const response = await fetch(
      `${url}/list/salary-income-list?page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "access-control-allow-origin": "*",
          authorization: "Bearer " + jwt,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}

export async function getAirdropTokenListApi(jwt, page = 1, limit = 10) {
  try {
    const response = await fetch(
      `${url}/list/airdrop-list?page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "access-control-allow-origin": "*",
          authorization: "Bearer " + jwt,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}

export async function withdrawRequestApi(jwt, amount, type) {
  try {
    const response = await fetch(`${url}/auth/withdraw`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "access-control-allow-origin": "*",
        authorization: "Bearer " + jwt,
      },
      body: JSON.stringify({ type, amount }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}

export async function getWithdrawListApi(jwt, page = 1, limit = 10) {
  try {
    const response = await fetch(
      `${url}/list/withdraw-list?page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "access-control-allow-origin": "*",
          authorization: "Bearer " + jwt,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}

export async function updateSalaryIndexApi(jwt) {
  try {
    const response = await fetch(`${url}/auth/update-salary-index`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "access-control-allow-origin": "*",
        authorization: "Bearer " + jwt,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
}
